import { Link } from "react-router";
import { HOME_TAB } from "@/app/primaryTab";
import { usePetCharacter } from "@/features/home/PetFigure";
import { useActiveHome } from "@/shared/session/householdContext";
import { ErrorState, Icon, LoadingState, Page, TopBar } from "@/shared/ui";
import { PlayUnavailable } from "./PlayUnavailable";
import { GAMES, playNotice, playStatus } from "./playStatus";
import "./play.css";

/**
 * 选游戏页 /play（入口在小窝：左侧快捷栏「和 TA 玩」、点 TA 的面板「和 TA 玩个小游戏」）。
 * 和当前这只宠物一起玩：顶上是宠物切换栏（PET_BAR_ROUTES 的 bar），换了宠物卡片跟着变。
 * 只有 TA 在家、醒着才能开局；不能时卡片照样列出、点不进去，写清原因，给回小窝的出口。成绩不存。
 * 不能时原因条下面另有一张「现在能做的事」（PlayUnavailable，R27 第 4 条）：TA 的小图、什么时候能玩、去哪儿。
 */
export function PlayHubPage() {
  const home = useActiveHome({ refetchInterval: 30_000 });
  const pet = home.data?.pet ?? null;
  const name = pet?.name ?? "TA";
  const status = playStatus(home.data);
  const character = usePetCharacter(status === "asleep" ? pet?.pet_id : null);
  return (
    <Page bare className="ps-play">
      <TopBar title={`和${name}玩`} back={HOME_TAB.to} sourceBack={{ fallback: HOME_TAB.to }} />
      {home.isPending ? (
        <LoadingState label="正在看 TA 在做什么…" lines={2} />
      ) : home.isError ? (
        <ErrorState error={home.error} onRetry={() => void home.refetch()} retrying={home.isFetching} />
      ) : (
        <>
          {status === "ok" ? null : (
            <>
              <div className="ps-play__notice" role="status">
                <p>{playNotice(status, name)}</p>
                <Link className="ps-btn ps-btn--secondary ps-btn--sm" to={HOME_TAB.to}>
                  回小屋
                </Link>
              </div>
              {home.data ? <PlayUnavailable status={status} snapshot={home.data} character={character} /> : null}
            </>
          )}
          <ul className="ps-play__games" aria-label="小游戏">
            {GAMES.map((game) => {
              const body = (
                <>
                  <span className="ps-play__icon" aria-hidden="true">
                    <Icon name={game.icon} size={22} />
                  </span>
                  <span className="ps-play__text">
                    <span className="ps-play__title">{game.title}</span>
                    <span className="ps-play__line">{game.line}</span>
                  </span>
                </>
              );
              return (
                <li key={game.id}>
                  {status === "ok" ? (
                    <Link className="ps-play__card" to={game.path} aria-label={`${game.title}：${game.line}`}>
                      {body}
                    </Link>
                  ) : (
                    <div className="ps-play__card" aria-disabled="true" aria-label={`${game.title}：现在不能开局`}>
                      {body}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
          <p className="ps-play__foot">陪 TA 玩一会儿。</p>
        </>
      )}
    </Page>
  );
}
